/**************************************************
 * Nombre:       Dialogo_Ver_Deposito
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {Check} from "@mui/icons-material";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import Formulario_Deposito from "../Formularios/Formulario_Deposito";
import {useContext} from "react";
import {usuarioContext} from "../../App";
import {crearDeposito} from "../../CodNegocio/Depositos/crearDeposito";
import Formulario_Deposito_Ver from "../Formularios/Formulario_Deposito_Ver";

const Dialogo_Ver_Deposito = ({datos, cerrar, realizado}) => {
    const cData = useContext(usuarioContext)
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: cerrar,
        funcionDos: realizado
    })


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Deposito_Ver props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => cerrar()}
                    startIcon={<Check/>}
                >Cerrar Detalle</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Ver_Deposito